import(/* webpackMode: "eager" */ "/Users/craigshewry/madethis/sima/node_modules/.pnpm/next@14.2.35_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ItemCard"] */ "/Users/craigshewry/madethis/sima/src/components/ItemCard.tsx");
